export const DEPARTURES_QUERY = `query Departures(
    $customerCurrency: CustomerCurrency!
    $customerLanguage: CustomerLanguage!
  ) {
    trips(
      customerLanguage: $customerLanguage
    ) {
      code
      tripDepartures {
        id
        code
        departureDate
        returnDate
        status
        capacity
        occupancy
        remainingSpots {
          label
          count
          warningType
        }
        isFull
        isInsider
        specialLabel
        specialLabelNotes
        notes
        originalPrice(customerCurrency: $customerCurrency) {
          amount
          label
        }
        finalPrice(customerCurrency: $customerCurrency) {
          amount
          label
        }
        deposit(customerCurrency: $customerCurrency) {
          amount
          label
        }
        isBeingFilmed
        earlyBirds
        packLeader
        promo {
          promoText
        }
        discountType(customerCurrency: $customerCurrency)
      }
    }
  }
  `;
